import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/[locale]/(user)/error.tsx");
